/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/config/headerConfig.ts
 * Descrizione: Configurazione centralizzata CustomHeader per tutte le pagine
 *
 * USAGE:
 * import { mainHeaderConfig } from '@/config/headerConfig';
 * <CustomHeader {...mainHeaderConfig} />
 */

import type { CustomHeaderProps } from '../components/ui-kit-dialogicom/inputs/CustomHeader';

/**
 * Configurazione header principale per tutte le pagine
 * - Logo: Coronatek
 * - Titolo: Turbomanager
 * - Sottotitolo: Dalla presa in carico alla riconsegna
 * - Logout: Abilitato con JWT countdown
 * - Responsive: Full-width, stack su mobile
 */
export const mainHeaderConfig: CustomHeaderProps = {
  // Dimensioni
  width: 'full',
  height: '80px',

  // Layout
  layout: 'flex-3',
  responsive: {
    mobile: 'stack',
    tablet: 'compact'
  },

  // Background - Gradiente Coronatek (verde → turchese → blu, inclinato ~30°)
  background: {
    type: 'gradient',
    gradient: {
      from: '#5CC86B', // verde chiaro (sinistra basso)
      via: '#2C929F',  // turchese/cyan (centro)
      to: '#1664B6',   // blu (destra alto)
      direction: '30deg', // inclinato 30 gradi
      opacity: 100
    }
  },

  // Bordi
  border: {
    enabled: true,
    color: '#475569', // slate-600
    width: 1,
    radius: 0
  },

  // Logo Coronatek
  logo: {
    src: '/assets/Coronatek_Logo_92dpi_200x88-Bz4ITupL.webp',
    height: 50,
    align: 'left'
  },

  // Titolo
  title: {
    text: 'Turbomanager',
    font: 'montserrat',
    size: 'text-2xl',
    color: '#ffffff',
    align: 'center',
    weight: 'bold'
  },

  // Sottotitolo
  subtitle: {
    text: 'Dalla presa in carico alla riconsegna',
    font: 'inter',
    size: 'text-sm',
    color: '#e2e8f0', // slate-200 - più chiaro per miglior contrasto
    align: 'center'
  },

  // Logout con JWT
  logout: {
    enabled: true,
    useRealAuth: true,
    showCountdown: true,
    loginUrl: '/login',
    labels: {
      loggedIn: 'Logout',
      loggedOut: 'Login'
    }
  }
};

/**
 * Configurazione header per pagine admin/configurazione
 * (stesso di mainHeaderConfig ma con titolo diverso)
 */
export const adminHeaderConfig: CustomHeaderProps = {
  ...mainHeaderConfig,
  title: {
    text: 'Amministrazione',
    font: 'montserrat',
    size: 'text-2xl',
    color: '#ffffff',
    align: 'center',
    weight: 'bold'
  },
  subtitle: {
    text: 'Configurazione sistema',
    font: 'inter',
    size: 'text-sm',
    color: '#94a3b8',
    align: 'center'
  }
};
